import Card from 'react-bootstrap/Card';

const WordCard = ({ word, detail }) => {
  const def = detail?.definition?.definitions?.[0];
  if (!word || !def) return null;

  return (
    <Card style={{ border: '1px solid #dee2e6' }}>
      <Card.Body>
        <Card.Title as='h1' style={{ fontSize: '1.7em' }}>
          {word}
        </Card.Title>
        <Card.Subtitle className='text-muted'>{def.phonetic}</Card.Subtitle>
        <Card.Text as='div'>
          {def.homographs.map((hom, homIndex) => (
            <div key={homIndex} className='mt-3'>
              <h5 style={{ color: '#8e3dff' }}>{hom.partOfSpeech}</h5>
              <ol>
                {hom.senses.map((sense, senseIndex) => (
                  <li key={senseIndex} className='mb-2'>
                    <div>{sense.meaning}</div>
                    {sense.examples.map((example, exampleIndex) => (
                      <small key={exampleIndex} className='text-muted'>
                        "{example}"
                      </small>
                    ))}
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </Card.Text>
      </Card.Body>
      <Card.Footer style={{ padding: '0.25rem 0.75rem' }}>
        <div className='text-end ms-auto'>
          <small style={{ fontSize: '0.75em' }} className='text-muted'>
            Definition by <strong>Collins English Dictionary</strong>
          </small>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default WordCard;
